/** Пункты кабинета, которые есть только у аптеки. */
const SHOP_CABINET_PREFIXES = [
    '/profile/orders/',
    '/profile-clinic/showcase/',
    '/profile-clinic/orders/',
]

function withSlash(path: string): string {
    return path.endsWith('/') ? path : `${path}/`
}

export function isShopCabinetPath(path: string): boolean {
    const normalized = withSlash(path)

    return SHOP_CABINET_PREFIXES.some((prefix) => normalized.startsWith(prefix))
}

/** Локальная витрина на основном хосте: `/katalog`. */
export function isShopStorefrontPath(path: string): boolean {
    const normalized = withSlash(path)

    return normalized === '/katalog/' || normalized.startsWith('/katalog/')
}

export function omitShopMenuItems<T extends {link: string, separatorAfter?: boolean}>(items: readonly T[], enabled: boolean): T[] {
    if (enabled) {
        return [...items]
    }

    const kept: T[] = []

    for (const item of items) {
        if (!isShopCabinetPath(item.link)) {
            kept.push(item)
            continue
        }

        const previous = kept.at(-1)
        if (item.separatorAfter && previous && !previous.separatorAfter) {
            kept[kept.length - 1] = {...previous, separatorAfter: true}
        }
    }

    return kept
}

export function omitShopCatalogTab<T extends Record<string, string>>(tabs: T, enabled: boolean): T {
    if (enabled || !('catalog' in tabs)) {
        return tabs
    }

    const {catalog: _catalog, ...rest} = tabs

    return rest as T
}
